// extracted by mini-css-extract-plugin
module.exports = {"root":"component_root__1sOPD"};